(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["codexSpecial"] = factory();
	else
		root["codexSpecial"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Special contrast verison for websites
	 *
	 * @link https://github.com/codex-team/codex.special
	 * @author Codex Team — ifmo.su
	 *   Vitaly Guryn    https://github.com/talyguryn
	 *   Savchenko Petr  https://github.com/neSpecc
	 * @version 1.2.1
	 */
	
	/** Script */
	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (function () {
	
	    /**
	     * Multilanguage support
	     * @private
	     */
	    var DICT = __webpack_require__(2);
	
	    /**
	     * CSS classes config
	     * @private
	     */
	    var classes = __webpack_require__(3);
	
	    /**
	     * Texts from dictionary
	     * @private
	     */
	    var texts = null;
	
	    /**
	     * Static nodes
	     * @private
	     */
	    var nodes = {
	
	        toolbar          : null,
	        colorSwitchers   : [],
	        textSizeSwitcher : null,
	
	    };
	
	    /**
	     * Names for states saved in localStorage
	     * @private
	     */
	    var localStorageBadges = {
	
	        textSise : 'codex-special__text-size',
	        color    : 'codex-special__color',
	
	    };
	
	    /**
	     * Settings for codexSpecial block
	     *
	     * blockId — at the end of which block you want to place codexSpecial
	     * scriptLocation — path to codexSpecial styles file
	     * lang — language for the codexSpecial from DICT_
	     */
	    var initialSettings = {
	
	        blockId  : null,
	        lang     : 'ru',
	        position : 'top-right',
	
	    };
	
	    /**
	     * Public methods and properties
	     * @constructor
	     */
	    var _codexSpecial = function () {};
	
	    /**
	     * Public initialization method
	     * @param {Object} settings are
	     *       - blockId - if passed, toolbar will be appended to this block
	     *                   otherwise, it will be fixed in window
	     */
	    _codexSpecial.prototype.init = function (settings) {
	
	        /** 1. Save initial settings to the private property */
	        fillSettings_(settings);
	
	        /** 2. Make interface */
	        makeUI_();
	
	        /** 3. Add listeners */
	        addListeners_();
	
	        /** 4. Check localStorage for settings */
	        loadSettings_();
	
	    };
	
	
	    /**
	     * Fills initialSettings
	     * @private
	     */
	    function fillSettings_(settings) {
	
	        for (var param in settings) {
	
	            initialSettings[param] = settings[param];
	
	        }
	
	    }
	
	    /**
	     * Loads requiered stylesheet
	     * @private
	     */
	    function loadStyles_() {
	
	        var stylesBlock = document.createElement('STYLE');
	
	        var styles = __webpack_require__(4);
	
	        stylesBlock.innerHTML = styles[0][1];
	
	        document.head.appendChild(stylesBlock);
	
	    };
	
	    /**
	     * Interface maker
	     * @private
	     */
	    function makeUI_() {
	
	        /** 0. Init dictionary */
	        texts = DICT[initialSettings.lang];
	
	        /** 1. Make Toolbar and Switchers */
	        var toolbar          = draw_.toolbar(),
	            textSizeSwitcher = draw_.textSizeSwitcher();
	
	        /** 2. Append text size switcher */
	        toolbar.appendChild(textSizeSwitcher);
	
	        /** 3. Append color switchers */
	        for (var color in classes.colorSwitchers) {
	
	            var circle = draw_.colorSwitcher(color);
	
	            circle.dataset.style = color;
	
	            toolbar.appendChild(circle);
	
	            nodes.colorSwitchers.push(circle);
	
	        }
	
	        nodes.toolbar = toolbar;
	        nodes.textSizeSwitcher = textSizeSwitcher;
	
	        appendPanel_();
	
	    }
	
	    /**
	     * Toolbar positioning method
	     * @private
	     */
	    function appendPanel_() {
	
	        if (initialSettings.blockId) {
	
	            var blockHolder = document.getElementById(initialSettings.blockId);
	
	            if (blockHolder) {
	
	                blockHolder.appendChild(nodes.toolbar);
	
	                nodes.toolbar.classList.add(classes.toolbar.state.included);
	
	                return;
	
	            }
	
	            initialSettings.blockId = '';
	
	        }
	
	        document.body.classList.add(classes.body.excludeModificator);
	        nodes.toolbar.classList.add(classes.toolbar.state.excluded);
	
	        if (initialSettings.position) {
	
	            switch (initialSettings.position) {
	
	                case 'top-left':
	                    nodes.toolbar.classList.add(
	                        classes.toolbar.position.top,
	                        classes.toolbar.position.left
	                    ); break;
	
	                case 'bottom-right':
	                    nodes.toolbar.classList.add(
	                        classes.toolbar.position.bottom,
	                        classes.toolbar.position.right
	                    ); break;
	
	                case 'bottom-left':
	                    nodes.toolbar.classList.add(
	                        classes.toolbar.position.bottom,
	                        classes.toolbar.position.left
	                    ); break;
	
	                // 'top-right'
	                default:
	                    nodes.toolbar.classList.add(
	                        classes.toolbar.position.top,
	                        classes.toolbar.position.right
	                    ); break;
	
	            }
	
	        }
	
	        document.body.appendChild(nodes.toolbar);
	
	    }
	
	    /**
	     * Add click listeners to text and circles
	     * @private
	     */
	    function addListeners_() {
	
	        nodes.colorSwitchers.map(function (switcher, index) {
	
	            switcher.addEventListener('click', changeColor_, false);
	
	        });
	
	        nodes.textSizeSwitcher.addEventListener('click', changeTextSize_, false);
	
	    }
	
	    /**
	     * Get special setting params from localStorage and enable it
	     * @private
	     */
	    function loadSettings_() {
	
	        var color    = window.localStorage.getItem(localStorageBadges.color),
	            textSize = window.localStorage.getItem(localStorageBadges.textSize),
	            textSizeSwitcher;
	
	        if (color) {
	
	            nodes.colorSwitchers.map(function (switcher, index) {
	
	                if (switcher.dataset.style == color) {
	
	                    changeColor_.call(switcher);
	
	                }
	
	            });
	
	        }
	
	        if (textSize) {
	
	            textSizeSwitcher = nodes.textSizeSwitcher;
	
	            changeTextSize_.call(textSizeSwitcher);
	
	        }
	
	    }
	
	    /**
	     * Set special color scheme
	     * @private
	     */
	    function changeColor_() {
	
	        if (this.classList.contains(classes.circle.state.enabled)) {
	
	            return dropColor_();
	
	        }
	
	        dropColor_();
	
	        nodes.colorSwitchers.map(function (switcher, index) {
	
	            switcher.classList.add(classes.circle.state.disabled);
	
	        });
	
	        this.classList.remove(classes.circle.state.disabled);
	
	        this.classList.add(classes.circle.state.enabled);
	
	        window.localStorage.setItem(localStorageBadges.color, this.dataset.style);
	
	        document.body.classList.add(classes.colorSwitchers[this.dataset.style]);
	
	    }
	
	    /**
	     * Drop special color scheme
	     * @private
	     */
	    function dropColor_() {
	
	        for (var color in classes.colorSwitchers) {
	
	            document.body.classList.remove(classes.colorSwitchers[color]);
	
	        }
	
	        nodes.colorSwitchers.map(function (switcher, index) {
	
	            switcher.classList.remove(classes.circle.state.disabled, classes.circle.state.enabled);
	
	        });
	
	        window.localStorage.removeItem(localStorageBadges.color);
	
	    }
	
	    /**
	     * Set increased text size
	     * @private
	     */
	    function changeTextSize_() {
	
	        if (document.body.classList.contains(classes.textSizeIncreased)) {
	
	            return dropTextSize_();
	
	        }
	
	        dropTextSize_();
	
	        nodes.textSizeSwitcher.innerHTML = '<i class="' + classes.iconButton.elem + '"></i> ' + texts.decreaseSize;
	
	        window.localStorage.setItem(localStorageBadges.textSize, 'big');
	
	        document.body.classList.add(classes.textSizeIncreased);
	
	    }
	
	    /**
	     * Drop increased text size
	     * @private
	     */
	    function dropTextSize_() {
	
	        document.body.classList.remove(classes.textSizeIncreased);
	
	        nodes.textSizeSwitcher.innerHTML = '<i class="' + classes.iconButton.elem + '"></i> ' + texts.increaseSize;
	
	        window.localStorage.removeItem(localStorageBadges.textSize);
	
	    }
	
	    /**
	     * HTML elements maker
	     * @private
	     */
	    var draw_ = {
	
	        element : function (newElement, newClass) {
	
	            var block = document.createElement(newElement);
	
	            block.classList.add(newClass);
	
	            return block;
	
	        },
	
	        /**
	         * Codex special toolbar
	         */
	        toolbar : function () {
	
	            return draw_.element('DIV', classes.toolbar.elem);
	
	        },
	
	        /**
	         * Makes color switcher
	         * @param {string} type  - color string identifier
	         */
	        colorSwitcher : function (type) {
	
	            var colorSwitcher = draw_.element('SPAN', classes.circle.elem);
	
	            colorSwitcher.classList.add(classes.circle.prefix + type);
	
	            return colorSwitcher;
	
	        },
	
	        /**
	         * Makes text size toggler
	         */
	        textSizeSwitcher : function () {
	
	            var textToggler = draw_.element('SPAN', classes.textButton.elem);
	
	            textToggler.innerHTML = '<i class="' + classes.iconButton.elem + '"></i> ' + texts.increaseSize;
	
	            return textToggler;
	
	        }
	
	    };
	
	    /** Prepare stylesheets */
	    loadStyles_();
	
	    return new _codexSpecial();
	
	})();


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	/**
	 * Dictionary object
	 */
	
	module.exports = {
	
	    ru : {
	        increaseSize : 'Увеличить шрифт',
	        decreaseSize : 'Уменьшить шрифт',
	    },
	
	    en : {
	        increaseSize : 'Increase font',
	        decreaseSize : 'Decrease font',
	    },
	
	};


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	/**
	 * Classnames for elements and states
	 */
	
	module.exports = {
	
	    colorSwitchers : {
	        blue     : 'special-blue',
	        green    : 'special-green',
	        white    : 'special-white',
	    },
	
	    textSizeIncreased : 'special-big',
	
	    toolbar : {
	
	        elem : 'codex-special__toolbar',
	
	        state : {
	            included : 'codex-special__toolbar--included',
	            excluded : 'codex-special__toolbar--excluded',
	        },
	
	        position : {
	            top    : 'codex-special__toolbar--position-top',
	            bottom : 'codex-special__toolbar--position-bottom',
	            left   : 'codex-special__toolbar--position-left',
	            right  : 'codex-special__toolbar--position-right',
	        },
	
	    },
	
	    iconButton : {
	
	        elem : 'codex-special__toolbar-icon',
	
	    },
	
	    textButton : {
	
	        elem : 'codex-special__toolbar-text',
	
	    },
	
	    circle : {
	
	        elem : 'codex-special__circle',
	
	        prefix : 'codex-special__circle--',
	
	        state : {
	            enabled  : 'codex-special__circle--enabled',
	            disabled : 'codex-special__circle--disabled',
	        },
	
	    },
	
	    body : {
	
	        excludeModificator : 'codex-special--excluded',
	
	    },
	
	};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(5)();
	// imports
	
	
	// module
	exports.push([module.id, ".special-blue article,.special-blue aside,.special-blue div,.special-blue footer,.special-blue form,.special-blue header,body.special-blue{background-color:#c1d1e6!important;background-image:none!important;color:#3f5077!important}.special-blue *{box-shadow:none;border-color:hsla(0,0%,53%,.24)!important}.special-blue input,.special-blue textarea{background-color:#d9e4f7!important;color:#36465b!important}.special-blue a{color:#082a90!important}.special-blue a:hover{color:#0034d2!important}.special-green article,.special-green aside,.special-green div,.special-green footer,.special-green form,.special-green header,body.special-green{background-color:#2b2924!important;background-image:none!important;color:#33d24a!important}.special-green *{box-shadow:none;border-color:hsla(0,0%,53%,.24)!important}.special-green input,.special-green textarea{background-color:#211f1a!important;color:#44e963!important}.special-green a{color:#98ff81!important}.special-green a:hover{color:#c8ffbb!important}.special-white article,.special-white aside,.special-white div,.special-white footer,.special-white form,.special-white header,body.special-white{background-color:#121213!important;background-image:none!important;color:#666871!important}.special-white *{border-color:#212121!important;box-shadow:none}.special-white input,.special-white textarea{background-color:#1d1d1d!important;color:#fff!important}.special-white a{color:#9ea0ad!important}.special-white a:hover{color:#fff!important}.special-big div{font-size:20px;line-height:1.5em}.special-big div *{font-size:inherit!important;line-height:inherit}.special-big h1{font-size:2em!important;line-height:1.35em}.special-big h2{font-size:1.5em!important;line-height:1.35em}.special-big h3{font-size:1.17em!important;line-height:1.35em}.special-big h4{font-size:1.12em!important;line-height:1.35em}.special-big h5{font-size:.83em!important;line-height:1.35em}.special-big h6{font-size:.75em!important;line-height:1.35em}@font-face{font-family:codex-special;src:url(data:application/font-woff2;charset=utf-8;base64,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) format(\"woff2\"),url(data:application/font-woff;charset=utf-8;base64,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) format(\"woff\");font-weight:400;font-style:normal}.codex-special__toolbar{padding:15px!important;background-color:#fff;white-space:nowrap;z-index:9999;line-height:21px!important}html body .codex-special__toolbar{font-size:15px!important}.codex-special__toolbar--included{position:relative;border-top:1px solid #f2f4f8}.codex-special__toolbar--excluded{position:fixed;width:300px;border:1px solid #f2f4f8}.codex-special__toolbar--position-top{top:0;bottom:auto;border-radius:0 0 3px 3px;border-top:0}.codex-special__toolbar--position-bottom{top:auto;bottom:0;border-radius:3px 3px 0 0;border-bottom:0}.codex-special__toolbar--position-left{left:3%;right:auto}.codex-special__toolbar--position-right{right:3%;left:auto}.codex-special__toolbar-text{display:inline-block;vertical-align:middle;cursor:pointer;border-radius:5px}.codex-special__toolbar-text:hover{color:#3d82c1}.codex-special__toolbar-icon{display:inline-block;margin-right:.3em;margin-bottom:1px;vertical-align:text-bottom;line-height:1em;font-size:.84em;font-style:normal}.codex-special__toolbar-icon:before{content:\"A\";font-family:codex-special}.special-big .codex-special__toolbar-icon{line-height:.96em}.special-big .codex-special__toolbar-icon:before{content:\"B\"}.special-big .codex-special__toolbar,.special-blue .codex-special__toolbar,.special-green .codex-special__toolbar,.special-white .codex-special__toolbar{background-color:#fff812!important;color:#15130b!important;border-color:transparent!important}.special-big .codex-special__toolbar-text:hover,.special-blue .codex-special__toolbar-text:hover,.special-green .codex-special__toolbar-text:hover,.special-white .codex-special__toolbar-text:hover{color:#b00!important}@media (max-width:1000px){.codex-special__toolbar--excluded{top:auto;bottom:0;right:0;left:0;width:auto;border:1px solid #f2f4f8}.codex-special--excluded{padding-bottom:50px}}.codex-special__circle{display:inline-block;width:7px;height:7px;border:7px solid;vertical-align:middle;box-sizing:content-box;border-radius:50%;cursor:pointer;float:right}.codex-special__circle:not(:first-of-type){margin-right:5px}.codex-special__circle:hover{width:11px;height:11px;border-width:5px}.codex-special__circle--enabled{border-radius:10%}.codex-special__circle--disabled{opacity:.7}.codex-special__circle--disabled:hover{opacity:1}.codex-special__circle--blue{background-color:#36465b;border-color:#c5dfff!important}.codex-special__circle--green{background-color:#44e963;border-color:#7c766a!important}.codex-special__circle--white{background-color:#fff;border-color:#2b2a28!important}", ""]);
	
	// exports


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// codex-special.min.js